import React from 'react';
import SalesDashboard from 'components/app/crm/dashboard/sales/SalesDashboard';

const SalesDashboardPage = () => <SalesDashboard />;

export default SalesDashboardPage;
